import { render, staticRenderFns } from "./quanku.vue?vue&type=template&id=798220d9&scoped=true&"
import script from "./quanku.vue?vue&type=script&lang=js&"
export * from "./quanku.vue?vue&type=script&lang=js&"
import style0 from "./quanku.vue?vue&type=style&index=0&id=798220d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798220d9",
  null
  
)

export default component.exports